import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerService } from 'src/app/core/services/spinner.service';

@Component({
  selector: 'app-miteam-optional-lobby-dialog',
  templateUrl: './miteam-optional-lobby-dialog.component.html',
  styleUrls: ['./miteam-optional-lobby-dialog.component.scss']
})
export class MiteamOptionalLobbyDialogComponent implements OnInit {
  miteamForm = this.formBuilder.group ({
    optionalLobby: [false, []],
    confirmationInput: ['', [Validators.required,
                            Validators.pattern(new RegExp('^' + this.translateService.instant('delegateConfirmation.delegate') + '$', 'i')),]]
  });
  policyExist= false;
  showFormError = false;
  errMsgStyle: any = { 'max-width': '500px' };
  submitted = false;
  showRemoveButton: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<MiteamOptionalLobbyDialogComponent>,
      private translateService: TranslateService,
      private formBuilder: FormBuilder,
      private spinnerService: SpinnerService,
      private domSanitizer: DomSanitizer,
      private matIconRegistry: MatIconRegistry
  ) {
    this.matIconRegistry.addSvgIcon(
			'trash_can',
			this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/trash.svg")
		);
   }

  ngOnInit(): void {
    this.initForm();
    setTimeout( async() => {  // resolves timing issue due to spinner in getAccount call inside isOptionalLobbyPolicyApplied method
      this.showRemoveButton = await this.data.product.service.canBeStandalone(this.data.account);
      this.data.product.service.isOptionalLobbyPolicyApplied(this.data.account).then( value => {
        console.log("Optional lobby policy returned", value);
        this.policyExist = value.found;
        this.miteamForm.controls['optionalLobby'].patchValue(this.policyExist);
        this.spinnerService.hideSpinner();
      }, 100);
    });
  }

  initForm()
	{

  }

  optionalLobbyStateChanged(){
    this.showFormError = false;
    this.miteamForm.controls['confirmationInput'].patchValue('');
  }

  onCancel() {
    this.dialogRef.close( );
  }

  onRemoveIntegration()
	{
		console.log("Remove the integration - when successful, close the dialog");
		let result = 
		{
			remove: true
		}
		this.dialogRef.close( result);
	}
  
  onSave(){
    this.submitted = true;
    this.data.product.service.handleOptionalLobbyPolicyChange(this.data.account, this.miteamForm.controls['optionalLobby'].value)
            .then( value => {
              if (value === null) {
                this.miteamForm.controls['optionalLobby'].patchValue(this.policyExist);
                this.showFormError = true;
              }
              this.spinnerService.hideSpinner();
              this.submitted = false;
              if( value !== null ) {
                this.dialogRef.close();
              }
            });
  }
}
